import { Box } from '@mui/material';
import DashboardHeader from './DashboardHeader';
import DashboardCharts from './DashboardCharts';
import BecomeAdvertizer from './BecomeAdvertizer';
import { useEffect, useState } from 'react';
import axios from 'axios';
import { IDashboard } from '../../interfaces/dashboard.ts';

const Dashboard = () => {
	const [data, setData] = useState<IDashboard>();
	useEffect(() => {
		let user = localStorage.getItem('user');
		axios({
			method: 'GET',
			url: `/dashboard`,
		}).then(r => {
			if (r?.data?.success) {
				setData(r?.data?.data);
			}
		});
		if (!user) {
			axios({
				url: '/user',
				method: 'GET',
			}).then(res => {
				if (res.data.success) {
					localStorage.setItem('user', JSON.stringify(res.data.data));
				}
			});
		}
	}, []);

	return (
		<Box className="flex h-full w-full flex-col">
			<DashboardHeader data={data} />
			<Box className="flex flex-grow flex-col gap-y-[30px] pt-6">
				<DashboardCharts data={data} />
				<BecomeAdvertizer />
			</Box>
		</Box>
	);
};

export default Dashboard;
